export default {"src":"/_next/static/media/sberbank.853c7b21.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};